import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AlertTwoToneSvg from "@ant-design/icons-svg/es/asn/AlertTwoTone";
import AntdIcon from "../components/AntdIcon";
var AlertTwoTone = function AlertTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AlertTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  AlertTwoTone.displayName = 'AlertTwoTone';
}
export default /*#__PURE__*/React.forwardRef(AlertTwoTone);